import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const GetOtuProcessIdsEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.getOtuProcessIdsRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      const { projectId, blastType } = action.payload
      return ProjectRepository.getOtuProcessIds(projectId, blastType).pipe(
        mergeMap((response) =>
          of(
            project.getOtuProcessIdsRequestSuccess({
              projectId,
              blastType,
              data: response
            })
          )
        ),
        catchError((error) =>
          of(
            project.getOtuProcessIdsRequestFailure({
              projectId,
              blastType,
              error
            })
          )
        )
      )
    })
  )
